import React from "react"
import { View } from "react-native"
import CheckCircleIcon from "phosphor-react-native/src/icons/CheckCircle"
import CircleIcon from "phosphor-react-native/src/icons/Circle"
import { BFColors } from "@/constants/Colors"
import Prohibit from "phosphor-react-native/src/icons/Prohibit"

export type MilestoneStatus =
  | "completed"
  | "pending"
  | "needs_action"
  | "blocked"

interface MilestoneStatusMarkerProps {
  status: MilestoneStatus
  size?: number
}

export const MilestoneStatusMarker: React.FC<MilestoneStatusMarkerProps> = ({
  status,
  size = 24,
}) => {
  const IconComponent =
    status === "completed"
      ? CheckCircleIcon
      : status === "blocked"
        ? Prohibit
        : CircleIcon
  const color = status === "completed" ? "#2ADC83" : BFColors.midnightBlue

  return (
    <View className="items-center justify-center">
      <IconComponent
        size={size}
        color={color}
        weight={status === "completed" ? "fill" : "regular"}
      />
    </View>
  )
}
